import { useWindowSize } from 'usehooks-ts';
import { useTranslation } from 'react-i18next';
import Loader from '../../loader/Loader';
import CustomCard from '../../cards/CustomCard';
import SearchArticleResult from '../SearchArticleResult';
import { mdBreakpoint } from '../../../shared/constants';
import { SearchResultSort } from '../../../shared/enums';
import { SearchArticleResult as SearchArticleResultType } from '../../../redux/store/api/api';

interface SearchArticleCardProps {
  isLoading: boolean;
  searchResult: SearchArticleResultType;
  sortOption: SearchResultSort;
  onSortChange: (sort: SearchResultSort) => void;
}

export default function SearchArticleCard({
  isLoading,
  searchResult,
  sortOption,
  onSortChange,
}: SearchArticleCardProps) {
  const { width: windowWidth } = useWindowSize();
  const { t: translation } = useTranslation();

  return (
    <CustomCard
      helpId={windowWidth > mdBreakpoint ? undefined : 'help_4_7'}
      iconClass='icon-search'
      title={
        !isLoading
          ? `${searchResult.resultCount || '0'} ${translation('searchResults')}`
          : undefined
      }
      ariaLiveForTitle={isLoading ? undefined : 'assertive'}>
      <div aria-busy={isLoading}>
        {isLoading && <Loader />}
        {!isLoading && searchResult && (searchResult.resultCount || 0) > 0 && (
          <SearchArticleResult
            searchResult={searchResult}
            onSortChange={onSortChange}
            sortOption={sortOption}
          />
        )}
      </div>
    </CustomCard>
  );
}
